import {Component, forwardRef} from "@angular/core";
import {SearchModel} from "@fedeltapointofsale/data-client";
import {FUIAlertAction, FUIAlertActions, FUIAlertService} from "@fedeltapointofsale/ui";
import {AnalyticsService} from "../../../analytics/analytics.service";
import {
    SearchAction,
    SearchActionSelector
} from "../../../framework/entity/search/search-grid/actions/search-action.component";
import {
    CashManagementVerifyBalanceAction,
    CashManagementVerifyBalanceService
} from "../cash-management-verify-balance.service";
import {firstValueFrom} from "rxjs";

/**
 * SearchAction to verify balances
 */
@Component({
    selector: "wbo-cash-management-verify-balance-search-action",
    template: "",
    providers: [
        {
            provide: SearchActionSelector,
            useExisting: forwardRef(() => CashManagementVerifyBalanceSearchActionComponent),
            multi: true
        },
        CashManagementVerifyBalanceService
    ]

})
export class CashManagementVerifyBalanceSearchActionComponent implements SearchAction {

    constructor(private alertService: FUIAlertService,
                private searchModel: SearchModel<any>,
                private service: CashManagementVerifyBalanceService,
                private analyticsService: AnalyticsService) {
    }

    /**
     *
     * @returns {number}
     */
    getImportance(): number {
        return 50;
    }

    /**
     *
     * @param data
     * @returns {string}
     */
    getIcon(data: any): string {
        return "coin-verified";
    }

    getIconClass(data: any): string {
        return "";
    }

    getIconSize(data: any): number {
        return 17;
    }

    getName(data: any): string {
        return "wbo.cash-management.search.action.verifyBalance";
    }

    async doAction(data: any): Promise<void> {
        const action: FUIAlertAction = await firstValueFrom(this.alertService.showConfirmationOkCancel("wbo.cash-management.search.prompt.verifyBalance.heading",
            "wbo.cash-management.search.prompt.verifyBalance.message"));
        if (action === FUIAlertActions.OK_ACTION) {
            return this.service.performAction(new CashManagementVerifyBalanceAction(data["floatId"]));
        }
    }

    isAvailable(data: any): boolean {
        return data.firstBalanceDate && !data.verifyUser;
    }
}
